<div class="content-wrapper container-xxl p-0">
    <div class="content-body card-body card card-main-box">
        <!-- <div class="content-header">
            <h5 class="mb-0 text-black fw-700 fs-14  mb-10">Add Currency</h5>
            <hr class="my-50 hr-color">
        </div> -->
        <div class="row flow-timer p-0 m-0" style="padding-top: 8px;" *ngIf="(!isCartEmpty && !isXplorerCardPurchase) || (!isCartEmpty && isXplorerCardPurchase && xplorerForexNow)">

            <div class="col-12">
                <div class="row mt-2 timer-wrapper">
                    <div class="col-md-5 d-flex align-content-center">
                        <!-- <i class="fa fa-clock-o" class="fs-12"></i> -->
                        <div class="time-icon-wrapper"> 
                            <img src="assets/images/icon/timer-icon.png" alt="Rate refresh timer" />
                        </div>

                        <label class="fs-10 fw-500 align-content-center ml-3">Rates will refresh after <span class="text-danger">{{ progressWidth }}</span> minutes </label>
                    </div>
                    <div class="col-md-7 align-content-center">
                        <div class="progress">
                            <div class="progress-bar bg-danger" role="progressbar" [ngStyle]="{'width.%': progressWidthInPercentage}" aria-valuemin="0"></div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="col-md-3"></div>

            <div class="col-md-6">
                <label class="text-danger fs-10 fw-500">Rates will refresh after {{ progressWidth }}
                    minutes
                </label>
                <div class="progress">
                    <div class="progress-bar bg-danger" role="progressbar"
                        [ngStyle]="{'width.%': progressWidthInPercentage}" aria-valuemin="0"></div>
                </div>
            </div> -->
        </div>
        <loader *ngIf="showLoader || showQuoteLoader"></loader>


        <div class="d-flex row align-items-stretch">
            <div class="currency-panel col-12 col-md-6 pl-0  vr-divider-line">
                <div class="currency-panel-box-wrapper">
                    <div class="card-amount-wrapper">
                        <div class="card-header text-black fw-500 fs-14 ">
                            <div class="row p-0 m-0">
                                <div class="col-12">
                                    <p class="py-0 my-0" *ngIf="!isXplorerCardPurchase">Add Currency to your Forex Card</p>
                                    <p class="py-0 my-0" *ngIf="isXplorerCardPurchase">Do you want to load your <b>Forex card?</b>*</p>
                                </div>
                                <div class="col-12 mt-1" *ngIf="isXplorerCardPurchase">
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="forex-now" value="now" name="xplorer-forex-option" [(ngModel)]="xplorerForexOptionNow" (change)="changeExplorerOption($event, 'NOW')">
                                        <label class="form-check-label" for="forex-now">Now</label>
                                    </div>
                
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="forex-later" value="later" name="xplorer-forex-option" [(ngModel)]="xplorerForexLater" (change)="changeExplorerOption($event, 'LATER')">
                                        <label class="form-check-label" for="forex-later">Later</label>
                                    </div>
                                </div>
                                <div class="col-12 mt-2" *ngIf="(!isXplorerCardPurchase) || (isXplorerCardPurchase && xplorerForexNow)">
                                    <div class="row p-0 m-0">
                                        <div class="col-md-6 col-6  mb-1 pl-0">
                                            <ng-select class="fs-11" placeholder="Select Currency" [items]="forexCardCurrencyList"
                                                [(ngModel)]="currencySelected" bindLabel="currencyCode" bindValue="currencyCode"
                                                [clearable]="false" [searchable]="false">
                                                <ng-template ng-option-tmp ng-label-tmp let-item="item">
                                                    <img src="assets/images/currencyFlag/{{item.currencyCode}}.png"
                                                        style="height:15px;width: 15px;" alt=""> {{item.currencyCode}}
                                                </ng-template>
                                            </ng-select>
                                        </div>
                                        <div class="col-md-6 col-6 mb-1 pl-0">
                                            <input type="text" class="form-control fs-11" [(ngModel)]="currencyCardAmount"
                                                placeholder="Amount*" aria-label="Amount" style="border-color: black"
                                                (keypress)="keyPressNumbers($event)" (paste)="onPaste($event)" />
                                        </div>
                                        <div class="col-md-12 col-12 mb-1 pl-0 text-right">
                                            <button type="submit" rippleEffect class="btn btn-primary btn-block fs-11"
                                                (click)="addCurrencyToCard()" style="height: 38px;">Add to Cart</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-amount-wrapper">


                    </div>
                </div>
                <div class="currency-panel-box-wrapper mt-1" *ngIf="(selectedCard.cardVendor != 'WSFXUNIMCC' && !isXplorerCardPurchase) || (isXplorerCardPurchase && xplorerForexNow)">
                    <div class="card-amount-wrapper">
                        <div class="card-header text-black fw-500 fs-14 ">
                            <div class="row p-0 m-0">
                                <div class="col-12">
                                    <p class="py-0 my-0" *ngIf="!isXplorerCardPurchase">Add Currency Notes (Cash)?</p>
                                    <p class="py-0 my-0" *ngIf="isXplorerCardPurchase">Add Currency Notes (Cash)?</p>
                                </div>
                                <div class="col-12 mt-1" *ngIf="isXplorerCardPurchase">
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="forex-cash-now" value="now" name="xplorer-cash-option" [(ngModel)]="xplorerCashNow" (change)="changeExplorerCashOption('NOW')">
                                        <label class="form-check-label" for="forex-cash-now">Now</label>
                                    </div>
                
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="forex-cash-later" value="later" name="xplorer-cash-option" [(ngModel)]="xplorerCashLater" (change)="changeExplorerCashOption('LATER')">
                                        <label class="form-check-label" for="forex-cash-later">Later</label>
                                    </div>
                                </div>
                                <div class="col-12 mt-2" *ngIf="(!isXplorerCardPurchase) || (isXplorerCardPurchase && isXplorerCashNow)">
                                    <div class="row p-0 m-0">
                                        <div class="col-md-6 col-6  mb-1 pl-0">
                                            <ng-select class="fs-12" [items]="cashCurrencyList"
                                                    placeholder="Select Currency" [(ngModel)]="currencySelectedCash"
                                                    bindLabel="currencyCode" bindValue="currencyCode" [clearable]="false"
                                                    [searchable]="false">
                                                    <ng-template ng-option-tmp ng-label-tmp let-item="item">
                                                        <img src="assets/images/currencyFlag/{{item.currencyCode}}.png"
                                                            style="height:15px;width: 15px;" alt=""> {{item.currencyCode}}
                                                    </ng-template>
                                            </ng-select>
                                        </div>
                                        <div class="col-md-6 col-6 mb-1 pl-0">
                                                <input type="text" class="form-control fs-11" [(ngModel)]="currencyAmountCash" placeholder="Amount *" aria-label="Amount" style="border-color: black"
                                                    (keypress)="keyPressNumbers($event)" (paste)="onPaste($event)" />
                                        </div>
                                        <div class="col-md-12 col-12 mb-1 pl-0 text-right">
                                                <button type="submit" rippleEffect class="btn btn-primary btn-block fs-10" (click)="addCashCurrencyToCard()">Add Cash</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                
                
                </div>
        
        
                <div class="currency-panel-box-wrapper mt-1" *ngIf="isServingBranchIsVisible">
                        <div class="card-amount-wrapper">     
                            <div class="card-header text-black fw-500 fs-14 d-block ">
                                <div class="row">
                                    <div class="col-12">                    
                                        <section class="py-2" class="serving-branch">
                                            <div class=" text-black fw-500 fs-14">
                                                Select nearest serving branch
                                            </div>
                                            <ng-select name="selectBranchAddress" [items]="branchAddressList" bindLabel="address"
                                                placeholder="Select WSFx Branch" class="fs-12"
                                                (change)="selectDeliveryOfficeAddress($event)" [clearable]="false">
                                                <ng-template ng-option-tmp let-item="item" let-index="index">
                                                    <b>{{item.branchName}}</b><br>
                                                    <span class="addressDropDown">{{item.address}}</span>
                                                </ng-template>
                                            </ng-select>
                                        </section>
                                        <section style="background-color: #FF370026; margin-top: 10px;">
                                            <p class="p-1" style="font-size: 14px; line-height: 18px;">Note: Currency delivery is only
                                                available within 20 km of the selected branch. If delivery is not available, your
                                                currency order will be cancelled and only your card will be delivered via our courier
                                                partner.</p>
                                        </section>
                                    </div>
                                </div>   
                            </div>
                        </div>
                    </div>
        
            </div>
        
        
            <!-- <div class="vr-divider"></div> -->
        
        
            <div class="currency-panel col-12 col-md-6 pr-0">
                <div class="currency-panel-box-wrapper d-flex flex-row mb-2" *ngIf="(!isCartEmpty && !isXplorerCardPurchase) || (isXplorerCardPurchase && xplorerForexNow && !isCartEmpty)">
                    <div class="forex-item-list">
                        <table class="table table-bordered table-responsive product-info-tbl">
                            <caption style="display: none;">Your Cart Details</caption>
                            <thead>
                                <tr class="table-header">
                                    <th scope="col">Product</th>
                                    <th scope="col">Currency</th>
                                    <th scope="col">FX Amount</th>
                                    <th scope="col">Rate</th>
                                    <th scope="col">INR Amount</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody class="fs-10 text-black">
                                <tr *ngFor="let singleTransaction of quotationCurrencyResponsesList; let i = index">
                                    <th scope="row" class="mob-table">Product</th>
                                    <td>

                                        {{singleTransaction?.product}}
                                    </td>
                                    <th scope="row" class="mob-table">Currency</th>
                                    <td>
                                        {{singleTransaction?.currencyCode}}
                                    </td>
                                    <th scope="row" class="mob-table">FX Amount</th>
                                    <td>
                                        {{singleTransaction?.currencyAmount}}
                                    </td>
                                    <th scope="row" class="mob-table">Rate</th>
                                    <td>
                                        {{singleTransaction.rate}}
                                    </td>
                                    <th scope="row" class="mob-table">INR Amount</th>
                                    <td>
                                        {{singleTransaction.inrEquivalentAmountString}}
                                    </td>
                                    <th scope="row" class="mob-table">Action</th>
                                    <td>
                                        <span class="red-text-delete" (click)="removeCartItemClicked(singleTransaction)" >
                                            <img src="assets/images/icon/amount_delete.png" class="forex-item-action-icon" alt="" />
                                        </span>

                                        <!-- <span class="red-text-delete">
                                            <a (click)="removeCartItemClicked(singleTransaction)">Delete </a></span> -->

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="currency-panel-box-wrapper" *ngIf="isXplorerCardPurchase">
                    <div class="xplorer-breakup-wrapper">
                        <div class="table-responsive amout-breakup-bg">
                            <table class="table table-condensed table-borderless  fs-12" aria-label="Xplorer Card Details">
                                                        <caption class="visually-hidden">Xplorer Card Details</caption>
                                                        <thead>
                                                            <tr>
                                                                <th></th>
                                                                <th></th>
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                <tbody>
                                    <tr style="background-color: #E8E8E8;">
                                        <td class="thick-line text-black fw-600" colspan="4">
                                            <div class="d-flex flex-row">
                                                <div class="breakup-forex-icon"><img src="assets/images/icon/Card details.png" alt="" /></div><span>Xplorer Card Details</span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="no-line " colspan="3"><strong>Kit Fee : </strong></td>
                                        <td class="no-line text-right">₹ {{ xplorerCardQuote?.kitFee }} </td>
                                    </tr>
                                    <tr>
                                        <td class="no-line " colspan="3"><strong>GST</strong></td>
                                        <td class="no-line text-right">₹ {{ xplorerCardQuote?.gst }} </td>
                                    </tr>
                                    <tr style="border-top:1px solid #EBEBEB; background:#E8E8E8;">
                                        <td class="no-line text-black fw-800 pt-10" colspan="3"> {{ isCartEmpty ? 'Total Payable' : 'Sub Total' }}: </td>
                                        <td class="no-line text-right text-black fw-800 pt-10"> ₹ {{ xplorerCardQuote?.totalAmount }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="currency-panel-box-wrapper mt-2" *ngIf="(!isCartEmpty && !isXplorerCardPurchase) || (isXplorerCardPurchase && xplorerForexNow && !isCartEmpty)">
                    <div class="amount-breakup-wrapper">
                        <div class="table-responsive amout-breakup-bg">
                            <table class="table table-condensed table-borderless  fs-12" aria-label="Forex Details">
                                                        <caption class="visually-hidden">Forex Details</caption>
                                                        <thead>
                                                            <tr>
                                                                <th></th>
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                <tbody>
                                    <tr style="background-color: #E8E8E8;">
                                        <td class="thick-line text-black fw-600" colspan="4">
                                            <div class="d-flex flex-row">
                                                <div class="breakup-forex-icon"><img src="assets/images/icon/Forex Details.png" style="height: 25px;" alt="" /></div><span>Forex Details</span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="thick-line text-black fw-600" colspan="3"><strong>Amount</strong></td>
                                        <td class="thick-line text-right text-black fw-600 "> ₹
                                            {{quotationResponse?.billableAmountString}}
                                        </td>
                                    </tr>
                                    <!-- <tr>
                                        <td class="no-line " colspan="3"><strong>Forex Margin</strong></td>
                                        <td class="no-line text-right">₹ {{ quotationResponse?.marginChargesString}} </td>
                                    </tr> -->
                                    <tr
                                        *ngIf="quotationResponse?.finalChargesString != '0' && quotationResponse?.finalChargesString != '0.0' && quotationResponse?.finalChargesString != '0.00'">
                                        <td class="no-line " colspan="3"><strong>Service Charges </strong></td>
                                        <td class="no-line text-right">₹ {{ quotationResponse?.finalChargesString }} </td>
                                    </tr>
                                    <tr *ngIf="quotationResponse?.tcs?.tcsAmountString!=0.0">
                                        <td class="no-line " colspan="3"><strong>TCS ({{
                                                quotationResponse?.tcs?.tcsPercentageString }}%)</strong></td>
                                        <td class="no-line text-right">₹ {{ quotationResponse?.tcs?.tcsAmountString }} </td>
                                    </tr>
                                    <tr>
                                        <td class="no-line " colspan="3"><strong>GST</strong></td>
                                        <td class="no-line text-right">₹ {{ quotationResponse?.gstString }} </td>
                                    </tr>
                                    <tr style="border-top:1px solid #EBEBEB;" *ngIf="isXplorerCardPurchase && xplorerForexNow && !isCartEmpty">
                                        <td class="no-line " colspan="3"><strong>Sub Total:</strong></td>
                                        <td class="no-line text-right">₹ {{ quotationResponse?.totalBillableAmountString | number }} </td>
                                    </tr>

                                    <tr style="border-top:1px solid #EBEBEB; background:#E8E8E8;">
                                        <td class="no-line text-black fw-800 pt-10" colspan="3">Total Payable: </td>
                                        <td class="no-line text-right text-black fw-800 pt-10"> ₹ {{ (quotationResponse?.xplorerCardTotalBillableAmount && quotationResponse?.xplorerCardTotalBillableAmount != 0) ? quotationResponse?.xplorerCardTotalBillableAmountString : 
                                            quotationResponse?.totalBillableAmountString | number }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>





        <div class="row pl-2 pr-2 mt-30" style="width: 90%; margin: auto;">
            <div class="col-md-5 col-lg-5 col-xl-5 col-sm-12 col-xs-12 card-order ">
                <div class="row">
                    <!-- <div class="col-md-11 mb-1" style="border: 1px solid black; border-radius: 10px;">

                        <div class="card-header text-black fw-500 fs-14" *ngIf="!isXplorerCardPurchase">
                            Add Currency to your Forex Card
                        </div>

                        <div class="card-header text-black fw-500 fs-14 " *ngIf="isXplorerCardPurchase">
                            <p class="py-0 my-0">Do you want to load your <span>Forex card?</span></p>

                            <div class="row mt-2">
                                <div class="col-md-12">
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="forex-now" value="now" name="xplorer-forex-option" [(ngModel)]="xplorerForexNow" (change)="changeExplorerOption('NOW')">
                                        <label class="form-check-label" for="forex-now">
                                            Now
                                        </label>
                                    </div>

                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="forex-later" value="later" name="xplorer-forex-option" [(ngModel)]="xplorerForexLater" (change)="changeExplorerOption('LATER')">
                                        <label class="form-check-label" for="forex-later">
                                            Later
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>                        


                        <div class="row" style="padding:0rem 1.5rem 0.2rem 1.5rem">

                            <div class="col-md-6 col-12  mb-1 pl-0">
                                <ng-select class="fs-11" placeholder="Select Currency" [items]="forexCardCurrencyList"
                                    [(ngModel)]="currencySelected" bindLabel="currencyCode" bindValue="currencyCode"
                                    [clearable]="false" [searchable]="false">
                                    <ng-template ng-option-tmp ng-label-tmp let-item="item">
                                        <img src="assets/images/currencyFlag/{{item.currencyCode}}.png"
                                            style="height:15px;width: 15px;"> {{item.currencyCode}}
                                    </ng-template>
                                </ng-select>
                            </div>
                            <div class="col-md-6 col-12 mb-1 pl-0">
                                <input type="text" class="form-control fs-11" [(ngModel)]="currencyCardAmount"
                                    placeholder="Amount*" aria-label="Amount" style="border-color: black"
                                    (keypress)="keyPressNumbers($event)" (paste)="onPaste($event)" />
                            </div>
                            <div class="col-md-12 col-12 mb-1 pl-0 text-right">
                                <button type="submit" rippleEffect class="btn btn-primary btn-block fs-11"
                                    (click)="addCurrencyToCard()" style="height: 38px;">Add to Cart</button>
                            </div>
                        </div>
                    </div> -->



                    <!-- <div class="col-md-11 mb-1" style="border: 1px solid black; border-radius: 10px;">

                            <section class="row" style="padding:0px 5px 0px 0px;"
                                *ngIf="selectedCard.cardVendor != 'WSFXUNIMCC'">
                                <div class="col-md-12">
                                    <div class="card " style="box-shadow : 0 0 0 0!important">
                                        <div class="card-header text-black fw-500 fs-14">
                                            Add Currency Notes (Cash)?
                                        </div>
                                        <div class="card-body row">
                                            <div class="col-md-6 col-12 mb-1 pl-0">
                                                <ng-select class="fs-12" [items]="cashCurrencyList"
                                                    placeholder="Select Currency" [(ngModel)]="currencySelectedCash"
                                                    bindLabel="currencyCode" bindValue="currencyCode" [clearable]="false"
                                                    [searchable]="false">
                                                    <ng-template ng-option-tmp ng-label-tmp let-item="item">
                                                        <img src="assets/images/currencyFlag/{{item.currencyCode}}.png"
                                                            style="height:15px;width: 15px;" alt=""> {{item.currencyCode}}
                                                    </ng-template>
                                                </ng-select>
                                            </div>
                                            <div class="col-md-6 col-12 mb-1 pl-0">
                                                <input type="text" class="form-control fs-11"
                                                    [(ngModel)]="currencyAmountCash" placeholder="Amount *"
                                                    aria-label="Amount" style="border-color: black"
                                                    (keypress)="keyPressNumbers($event)" (paste)="onPaste($event)" />
                                            </div>
                                            <div class="col-md-12 col-12 pl-0 text-right">
                                                <button type="submit" rippleEffect class="btn btn-primary btn-block fs-10"
                                                    (click)="addCashCurrencyToCard()">Add Cash</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                    </div> -->

                            
                    <loader *ngIf="showLoader"></loader>

                </div>




            </div>
            <div class="col-lg-1"></div>

            <!-- <div class="col-md-6 col-xl-6 col-lg-6 col-sm-12 col-xs-12  " *ngIf="!!isCartEmpty">
                <div class="row">
                    <div class="col-md-12  mb-5">
                        <h6 class="content-header-title float-left mb-0" style="color: #000000 !important">
                            Your Cart Details
                        </h6>
                    </div>

                </div>
                <div>
                    <table class="table table-bordered table-responsive">
                        <thead>
                            <tr class="table-header">
                                <th>Product</th>
                                <th>Currency</th>
                                <th>FX Amount</th>
                                <th>Rate</th>
                                <th>INR Amount</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody class="fs-10 text-black">
                            <tr *ngFor="let singleTransaction of quotationCurrencyResponsesList; let i = index">
                                <th class="mob-table">Product</th>
                                <td>

                                    {{singleTransaction?.product}}
                                </td>
                                <th class="mob-table">Currency</th>
                                <td>
                                    {{singleTransaction?.currencyCode}}
                                </td>
                                <th class="mob-table">FX Amount</th>
                                <td>
                                    {{singleTransaction?.currencyAmount}}
                                </td>
                                <th class="mob-table">Rate</th>
                                <td>
                                    {{singleTransaction.rate}}
                                </td>
                                <th class="mob-table">INR Amount</th>
                                <td>
                                    {{singleTransaction.inrEquivalentAmountString}}
                                </td>
                                <th class="mob-table">Action</th>
                                <td>
                                    <span class="red-text-delete"><a
                                            (click)="removeCartItemClicked(singleTransaction)">Delete </a></span>

                                </td>
                            </tr>
                        </tbody>
                    </table>


                </div> -->
                <!-- <section class="invoice-preview-wrapper">
                    <div class="table-responsive mt-15 amout-breakup-bg">
                        <table class="table table-condensed table-borderless  fs-12">
                            <tbody>
                                <tr style="border-top:1px solid #f4f4f4">
                                    <td colpan="2"></td>
                                </tr>
                                <tr>
                                    <td class="thick-line text-black fw-600" colspan="3"><strong>Amount</strong></td>
                                    <td class="thick-line text-right text-black fw-600 "> ₹
                                        {{quotationResponse?.billableAmountString}}
                                    </td>
                                </tr> -->
                                <!-- <tr>
                                    <td class="no-line " colspan="3"><strong>Forex Margin</strong></td>
                                    <td class="no-line text-right">₹ {{ quotationResponse?.marginChargesString}} </td>
                                </tr> -->
                                <!-- <tr
                                    *ngIf="quotationResponse?.finalChargesString != '0' && quotationResponse?.finalChargesString != '0.0' && quotationResponse?.finalChargesString != '0.00'">
                                    <td class="no-line " colspan="3"><strong>Service Charges </strong></td>
                                    <td class="no-line text-right">₹ {{ quotationResponse?.finalChargesString }} </td>
                                </tr>
                                <tr *ngIf="quotationResponse?.tcs?.tcsAmountString!=0.0">
                                    <td class="no-line " colspan="3"><strong>TCS ({{
                                            quotationResponse?.tcs?.tcsPercentageString }}%)</strong></td>
                                    <td class="no-line text-right">₹ {{ quotationResponse?.tcs?.tcsAmountString }} </td>
                                </tr>
                                <tr>
                                    <td class="no-line " colspan="3"><strong>GST</strong></td>
                                    <td class="no-line text-right">₹ {{ quotationResponse?.gstString }} </td>
                                </tr>

                                <tr style="border-top:1px solid #bdbcbc">
                                    <td class="no-line text-black fw-800 pt-10" colspan="3"> Total Payable </td>
                                    <td class="no-line text-right text-black fw-800 pt-10"> ₹ {{
                                        quotationResponse?.totalBillableAmountString | number }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </section> -->

            <!-- </div> -->
        </div>
        <!-- <hr class="dotted"> -->

        <div class="d-flex justify-content-between mt-20">
            <button type="button" class="btn btn-back prev-back-btn fs-12" rippleEffect (click)="backClick()">
                <i data-feather="arrow-left" class="align-middle mr-sm-25 mr-0"></i>
                <span class="align-middle">Back</span>
            </button>
            <button type="submit" class="btn btn-primary btn-next fs-12"
                [ngClass]="isFromReload == true ? 'reload-card-order-start' : 'buy-new-card-order-start'"
                (click)="cartInitiate()" rippleEffect>
                <span class="align-middle">Next</span>
                <i data-feather="arrow-right" class="align-middle ml-sm-25 ml-0"></i>
            </button>
        </div>
    </div>
</div>
<ng-template #deleteConfirmationDailog let-modal>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <div class="col-md-12">
            <div class="text-center text-black fw-500 mt-10 mb-10 fs-12">
                <span class="text-center"> Do you want to Remove </span> <br> {{deleteItemMesg}}
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-6 modal-footer border-right">
            <div class="row col-12">
                <div class="fw-500 fs-12 blue-text" (click)="removeCartItem()"
                    style="cursor: pointer; padding-left: 50%;">
                    Yes
                </div>
            </div>
        </div>
        <div class="col-6 modal-footer border-left">
            <div class="row col-12">
                <div class="fw-500 fs-12 red-text-delete" (click)="modal.dismiss('Cross click')"
                    style="cursor: pointer; padding-left: 40%;">
                    No
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #isInTripModal let-modal>
    <!-- <div class="modal-header modal-custom-header">
        
        <button type="button" class="btn btn-link close popup-close-btn" (click)="modal.dismiss('Cross click')" aria-label="Close">
            X
        </button>
        <h6 class="modal-title popup-modal-title text-center"><b>Set your card PIN</b></h6>
    </div> -->
    <div class="modal-body currencyWallet-modal-body" tabindex="0" ngbAutofocus>
        <div class="row">
            <div class="col-12 text-center">
                <p class="text-center m-4 " style="font-size: 18px;">Looks like a new trip ?</p>
            </div>
            <div class="col-12 text-center">
                <div class="row">
                    <div class="col-6 text-right">
                        <button class="btn btn-primary btn-gradient link btn-set-pin"
                            (click)="setIsInTrip('NO')">Yes</button>
                    </div>
                    <div class="col-6 text-left">
                        <button class="btn btn-primary btn-gradient link btn-set-pin"
                            (click)="setIsInTrip('YES')">No</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #travelDocumentInstructionModal let-modal>
    <div class="modal-header">
        <h6 class="modal-title text-center text-black fw-700 w-100"><b>Travel Documents checklist:</b></h6>
        <button type="button" class="close" (click)="closeTravelDocumentInstrModal()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <div class="row">
            <div class="col-md-12">
                <div class=" text-black fw-500 mt-10 mb-10 fs-12">
                    <strong>To proceed with your transaction, please ensure you have the following:</strong>
                </div>
            </div>
            <div class="col-md-12">
                <ul>
                    <li>Visa</li>
                    <li>Onward Air Ticket</li>
                </ul>
            </div>            

            <div class="col-md-12">
                <span class="custom-control custom-checkbox mb-20">
                    <input type="checkbox" class="custom-control-input" id="confirmForDocument" [(ngModel)]="isCheckedForDoument"  />
                    <label for="confirmForDocument" class="custom-control-label fs-12" style="border-color: black;">I confirm that I have all the listed documents above.</label>
                </span>
            </div>    

        </div>
    </div>
    <div class="modal-footer text-center m-auto">
        <button type="button" class="btn btn-primary btn-next fs-12" (click)="proceedChecklist()">Proceed</button>
    </div>
</ng-template>


<ng-template let-modal #xplorerCardBuyError>
    <!-- <div class="modal-header">
        <h6 class="modal-title" id="myModalLabel1"></h6>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div> -->
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <h5 class="text-center fs-14">Dear Customer,</h5><br>
        <h5 class="text-center fs-14">{{ xplorerCardError }}</h5><br>
    </div>
    <div class="row">
        <button class="mx-auto mt-10 mb-10 btn btn-primary fs-10" rippleEffect (click)="closeAndGoToCards()">
        Okay </button>
    </div>
</ng-template>